import React, { Component } from 'react';
import Header from './Header';
import Footer from '../../components/Footer/Footer';
import Helmet from 'react-helmet';

class Faq extends Component {
  render() {
    const styles = require('./Faq.less');

    return [
      <Helmet
        key="0"
        htmlAttributes={{ lang: 'ru-RU' }}
        title="FAQ – Часто задаваемые вопросы онлайн сервиса для создания опросов и сбора отзывов (обратной связи) / оценок и аналитики от Клиентов (ЦА) – Mvoter.com"
        meta={[{"name": "description", "content": "Часто задаваемые вопросы / FAQ MVoter – Онлайн платформа для создания моментальной обратной связи с Клиентами! Онлайн сервис по сбору отзывов ✓ Анализ обратной связи от ЦА и потребителей ✓ Управление удовлетворенностью клиентов ✓ Отрасли использования опросника: Рестораны, Банки, Здравоохранение, Торговля, Общественный транспорт ☎ +7 (747) 359-5959"}]}
      />,
      <Header key="1" />,
      <div key="2" className={ styles.content }>
        <div className={ styles.inner }>
          <div className={ styles.wrap }>
            <div className={ styles.header }>
              <h2>Чем мы можем вам сегодня помочь?</h2>
              <img src="./images/faq.svg" width="580" height="340" alt="faq" />
            </div>
            <h1>FAQ – Часто задаваемые вопросы MVoter</h1>
            <p>Общие вопросы</p>
            <ul className={ styles.list }>
              <li>Кому нужна система MVoter?</li>
              <li>Что из себя представляет система MVoter? Как она работает?</li>
              <li>У меня очень маленький бизнес, подходит ли MVoter для меня?</li>
              <li>У нас огромный бизнес с десятками региональных филиалов, с сотнями точек обслуживания, с тысячами сотрудников обслуживающего персонала, и десятками и сотнями тысяч покупателей и клиентов ежедневно. Подходит ли MVoter для нас?</li>
              <li>В каких сферах и отраслях можно использовать систему MVoter?</li>
              <li>Мы бы хотели чтобы наши клиенты оценивали не только в целом наш сервис или компанию, но и персонально каждого сотрудника, отдельные службы, помещения, предметы и т.д., возможно ли это с MVoter?</li>
              <li>Можно ли адаптировать вашу систему под наш корпоративный дизайн и бренд концепцию?</li>
            </ul>
            <p>Дизайн информеров</p>
            <ul className={ styles.list }>
              <li>Что такое информеры?</li>
              <li>У меня нет возможности самому нарисовать информер (постер или бейджик), как вы можете мне помочь?</li>
            </ul>
            <p>Настройка и внедрение системы MVoter</p>
            <ul className={ styles.list }>
              <li>Сколько времени нужно, чтобы настроить и внедрить систему обратной связи с Целевой Аудиторией MVoter?</li>
              <li>Нужно ли нам дополнительное оборудование для использования MVoter?</li>
            </ul>
          </div>
        </div>
      </div>,
       <Footer key="3" subId="page" />
    ]
  }
}

export default Faq;
